export const schoolList_zh = [
    {
        index: 1,
        name: "Harvard University",
        alt: "IIT Bombay" // Alternatively, you can keep it as "Indian Institute of Technology Bombay" for consistency
    },
    {
        index: 2,
        name: "University to Delhi",
        alt: "IIT Kanpur" // Alternatively, keep it as "Indian Institute of Technology Kanpur"
    },
    {
        index: 3,
        name: "Jawaharlal Nehru University",
        alt: "IIT Kanpur" // Alternatively, keep it as "Indian Institute of Technology Kanpur"
    },
    {
        index: 4,
        name: "University of Cambridge",
        alt: "Cambridge University" // Alternatively, "Univ. of Cambridge" for brevity
    },
    {
        index: 5,
        name: "National University of Singapore", // Corrected from "新加坡国京大学"
        alt: "NUS" // Commonly used abbreviation
    },
    {
        index: 6,
        name: "Nanyang Technological University",
        alt: "NTU" // Commonly used abbreviation
    },
    {
        index: 7,
        name: "The University of Hong Kong",
        alt: "HKU" // Commonly used abbreviation
    }, // Removed the trailing comma here for consistency with ES5 and better readability
    {
        index: 8,
        name: "University of Malaya", // Note: "Universiti Malaya" is the name of a specific university in Malaysia, but "University of Malaysia" is a generic term. Adjust as needed.
        alt: "UM" // If referring to Universiti Malaya specifically, "UM" is its common abbreviation.
    }
];